import React, { Component } from "react";
import CustomLoader from "../../common/Loader";
import { getREDCapSurveyDetails } from "../../../services/formService";
import { ToastContainer } from "react-toastify";
import { toaster } from '../../../config';

class REDCapSurveyViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Widget_ID: this.props.Widget_ID,
            //Tabs: [{ Tab_ID: -1, Tab_Name: "", Tab_Form_ID: "" }],
            //selected_tab: 0,
            loading: true,
            preloadData: {
                Display_Name: '',
                Survey_ID: ''
            }
        };
    }

    async componentDidMount() {
        this.setState({ preloadData: (await getREDCapSurveyDetails(this.state.Widget_ID)).data[0] || {}, loading: false });
        //let toastType= 'error', toastMsg = 'Error: Data Fetch';
        //(this.state.preloadData.Display_Name) && (toastType = 'success') && (toastMsg = 'Data Fetch Success')
        //toaster(toastType, toastMsg);
    }

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }
        return (
            <div className="card mb-4 d-block">
                <div className="card-header">
                    <span className="form-control">{this.state.preloadData.Display_Name}</span>
                </div>
                <div className="card-body">
                    <iframe src={this.state.preloadData.Survey_ID} className="iframe_body embed-responsive iframe" title={this.state.preloadData.Display_Name}></iframe>
                </div>
                <ToastContainer/>
            </div>
        );
    }
}

export default REDCapSurveyViewer;